import { CreditCard, Banknote, Check } from "lucide-react";

const methods = [
  { key: "manual", label: "Pagamento Manual", desc: "Konbini, transferência bancária ou dinheiro", icon: Banknote },
  { key: "credit_card", label: "Cartão de Crédito", desc: "Em breve - Integração futura", icon: CreditCard, disabled: true },
];

export default function StepPayment({ method, setMethod, notes, setNotes }) {
  return (
    <div data-testid="step-payment">
      <h2 className="crm-heading mb-2">Pagamento</h2>
      <p className="text-sm mb-6" style={{ color: "var(--crm-text-muted)" }}>
        Selecione o método de pagamento.
      </p>

      <div className="space-y-3 max-w-lg mb-8">
        {methods.map((m) => {
          const Icon = m.icon;
          const selected = method === m.key;
          return (
            <button
              key={m.key}
              onClick={() => !m.disabled && setMethod(m.key)}
              disabled={m.disabled}
              data-testid={`wizard-payment-${m.key}`}
              className="w-full crm-card p-5 flex items-center gap-4 text-left transition-all"
              style={{
                borderColor: selected ? "var(--crm-accent)" : undefined,
                opacity: m.disabled ? 0.5 : 1,
                cursor: m.disabled ? "not-allowed" : "pointer",
              }}
            >
              <div className="w-12 h-12 rounded-xl flex items-center justify-center flex-shrink-0"
                style={{ background: selected ? "var(--crm-accent-subtle)" : "var(--crm-input-bg)", color: selected ? "var(--crm-accent)" : "var(--crm-text-dim)" }}>
                <Icon className="w-5 h-5" />
              </div>
              <div className="flex-1">
                <p className="text-sm font-semibold" style={{ color: "var(--crm-text)" }}>{m.label}</p>
                <p className="text-xs" style={{ color: "var(--crm-text-muted)" }}>{m.desc}</p>
              </div>
              {selected && (
                <div className="w-6 h-6 rounded-full flex items-center justify-center" style={{ background: "var(--crm-accent)", color: "white" }}>
                  <Check className="w-4 h-4" />
                </div>
              )}
            </button>
          );
        })}
      </div>

      <div className="max-w-lg">
        <label className="crm-label">Observações da venda</label>
        <textarea value={notes} onChange={(e) => setNotes(e.target.value)}
          data-testid="wizard-payment-notes" rows={3} className="crm-input resize-none"
          placeholder="Notas adicionais sobre a venda (opcional)" />
      </div>
    </div>
  );
}
